import React from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CodeSnippet = ({
  translationIndex,
  algoIndex,
  snippetIndex,
  snippet,
  handleCodeSnippetChange,
  handleDeleteCodeSnippet,
  programmingLanguages,
}) => {
   

  return (
    <Box sx={{ mb: 2, p: 1, border: "1px solid #ccc", borderRadius: 2 }}>
      <TextField
        label="Code Snippet"
        value={snippet.codeSnippet}
        onChange={(e) =>
          handleCodeSnippetChange(
            translationIndex,
            algoIndex,
            snippetIndex,
            "codeSnippet",
            e.target.value
          )
        }
        multiline
        rows={10}
        sx={{ mt: 2, width: "100%", fontFamily: "monospace" }}
      />
      <FormControl sx={{ mt: 2, minWidth: "200px" }}>
        <Select
          value={snippet.programmingLanguage}
          onChange={(e) =>
            handleCodeSnippetChange(
              translationIndex,
              algoIndex,
              snippetIndex,
              "programmingLanguage",
              e.target.value
            )
          }
          displayEmpty
        >
          <MenuItem value="" disabled>
            Select Language
          </MenuItem>
          {programmingLanguages.map((lang) => (
            <MenuItem key={lang.key} value={lang.key}>
              {lang.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Description"
        value={snippet.description}
        onChange={(e) =>
          handleCodeSnippetChange(
            translationIndex,
            algoIndex,
            snippetIndex,
            "description",
            e.target.value
          )
        }
        sx={{ mt: 2, width: "100%" }}
      />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={snippet.active}
              onChange={(e) =>
                handleCodeSnippetChange(
                  translationIndex,
                  algoIndex,
                  snippetIndex,
                  "active",
                  e.target.checked
                )
              }
            />
          }
          label="Active"
          sx={{ mt: 1 }}
        />
        <IconButton
          color="error"
          onClick={() =>
            handleDeleteCodeSnippet(translationIndex, algoIndex, snippetIndex)
          }
          sx={{ mt: 1 }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CodeSnippet;
